import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', {
  width: '100%',
  padding: '0',
})

export const OuterCard = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.white,
  borderRadius: '0.625rem',
  border: `0.0625rem solid ${$theme.colors.borderSubtle}`,
  margin: '0.0625rem 1rem 0.625rem 1rem',
  width: 'auto',
  overflow: 'hidden',
}))

export const Header = styled('div', ({ $theme }) => ({
  fontSize: '1rem',
  fontWeight: 600,
  color: $theme.colors.textNearBlack,
  backgroundColor: $theme.colors.white,
  padding: '0.7rem 1.2rem',
  borderBottom: `0.0625rem solid ${$theme.colors.borderSubtle}`,
}))

export const GrayBlock = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors.bgWash,
  width: '100%',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  border: 0,
  borderRadius: 0,
}))

export const GrayBlockContent = styled('div', {
  padding: '1.1rem 1.2rem',
})

export const List = styled('ul', {
  listStyle: 'none',
  padding: 0,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
})

export const ListItem = styled('li', ({ $theme }) => ({
  fontSize: '1rem',
  color: $theme.colors.textNearBlack,
  lineHeight: 1.7,
  marginBottom: '0.7rem',
  '&:last-child': {
    marginBottom: 0,
  },
  '& b': {
    fontWeight: 600,
  },
}))

export const LinkStyled = styled('a', ({ $theme }) => ({
  color: $theme.colors.primary350,
  textDecoration: 'underline',
  fontSize: '1rem',
  fontWeight: 400,
}))

export const StyledEmptyMessageContainer = styled(FlexCenterY, {
  padding: '0rem 1rem 1rem 1rem',
})

export const StyledEmptyIcon = styled(FlexCenterY, ({ $theme }) => ({
  display: 'inline-flex',
  color: $theme.colors.mono400,
  fontSize: '1.6rem',
  marginRight: '0.15rem',
  justifyContent: 'center',
}))

export const StyledEmptyText = styled('span', ({ $theme }) => ({
  paddingTop: '0.45rem',
  color: $theme.colors.grey,
}))
